import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1016"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.297 2.05a.7.7 0 0 0-.7.702v10.596H2.403V2.752a.704.704 0 0 0-.7-.702c-.384 0-.7.317-.7.702V14.05a.7.7 0 0 0 .7.702h12.594a.7.7 0 0 0 .7-.702V2.752a.7.7 0 0 0-.7-.702z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M4.133 8.073h2.648l-1.324 2.293a.701.701 0 0 0 1.213.701l1.324-2.293 1.324 2.293a.7.7 0 0 0 .956.256.701.701 0 0 0 .257-.957L9.206 8.073h2.648a.7.7 0 1 0 0-1.4H9.207l1.324-2.293a.701.701 0 0 0-1.214-.701L7.994 5.972 6.67 3.679a.701.701 0 0 0-1.213.701l1.324 2.293H4.133a.7.7 0 1 0 0 1.4z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }